// import component
import FormikContainer from "../Formik/FormikContainer";
import FieldContainer from "../Formik/FieldContainer";
import { ErrorMessage, Form } from "formik";
import DButton from "../DButton";
import DCard from "../DCard";
import DImage from "../DImage";
import { Spinner } from "@chakra-ui/react";
import ErrorMsg from "../Formik/Fields/ErrorMsg";
import { useRef } from "react";

const ProductSubForm = ({
  onSubmit,
  initialValues,
  validationSchema,
  btnText,
  providersOptions,
}) => {
  const fileRef = useRef();

  const setImageHandler = (value) => {
    if (value?.type) {
      return URL.createObjectURL(value);
    }
    return value;
  };
  const deleteImageHandler = (setFieldValue) => {
    fileRef.current.value = "";
    setFieldValue("productImage", "");
  };
  // const changeProductType = (e, setFieldValue) => {
  //     setFieldValue("isAuto", e.target.checked);
  // };
  // const changeAmountType = (e, setFieldValue) => {
  //     setFieldValue("enableAmount", e.target.checked);
  // };
  console.log(initialValues);
  return (
    <DCard className="mt-4">
      <FormikContainer
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ values, setFieldValue, isSubmitting }) => {
          return (
            <Form>
              <div className="flex justify-between md:justify-start gap-2">
                <div className="mb-4">
                  {/* <FieldContainer
                    type="switch"
                    name="enableAmount"
                    id="enableAmount"
                    label={
                      values.enableAmount
                        ? "ادخال الكمية (مفعل)"
                        : "ادخال الكمية (غير مفعل)"
                    }
                  /> */}
                </div>
                <div>
                  <FieldContainer
                    type="switch"
                    name="isAuto"
                    id="isAuto"
                    label={values.isAuto ? "معاملة آلية" : "معاملة يدوية"}
                  />
                  {/* <DSwitch
                                        name={"isAuto"}
                                        id={"isAuto"}
                                        onChange={e =>
                                            changeProductType(e, setFieldValue)
                                        }
                                    /> */}
                </div>
                {initialValues.productName && (
                  <div>
                    <FieldContainer
                      type="switch"
                      name="is_available"
                      id="is_available"
                      label={values.is_available ? "متاح" : "غير متاح"}
                    />
                  </div>
                )}
              </div>
              <div className="mb-10 flex flex-col items-center mx-auto text-center">
                <label className="mb-2" htmlFor="productImage">
                  صورة المنتج:
                </label>
                <FieldContainer
                  fileRef={fileRef}
                  name="productImage"
                  type="file"
                  accept="image/*"
                  id="productImage"
                  hidden
                />
                <div>
                  {values.productImage && (
                    <>
                      <div className="mb-4 relative sm:w-[250px] h-[250px] border border-light-color rounded-sm mx-auto">
                        <DImage
                          className="w-full h-full object-contain"
                          src={setImageHandler(values.productImage)}
                          alt={"product-image"}
                          load={true}
                        />
                      </div>
                      <DButton
                        onClick={() => deleteImageHandler(setFieldValue)}
                        className="text-white"
                        bgColor="danger"
                      >
                        حذف الصورة
                      </DButton>
                    </>
                  )}
                  <DButton
                    bgColor="secondry"
                    onClick={() => fileRef.current?.click()}
                  >
                    تحميل صورة
                  </DButton>
                  <div className="block">
                    <ErrorMessage name="productImage" component={ErrorMsg} />
                  </div>
                </div>
              </div>

              <div className="grid  grid-cols-2 gap-4">
                <FieldContainer
                  name="productName"
                  type="text"
                  label="الأسم"
                  id="productName"
                />
                <FieldContainer
                  name="productPrimaryName"
                  type="text"
                  label="اسم المنتج الرئيسي"
                  id="productPrimaryName"
                  disabled
                />
                {values.isAuto && (
                  <>
                    <FieldContainer
                      name="provider"
                      type="select"
                      label="ربط مع"
                      id="provider"
                      options={providersOptions}
                    />
                    <FieldContainer
                      name="productId"
                      type="text"
                      label="معرف المنتج (API ID)"
                      id="productId"
                    />
                  </>
                )}

                <FieldContainer
                  name="productPrice1"
                  type="text"
                  label="السعر (مستوى1)"
                  id="productPrice1"
                />
                {initialValues.productName && (
                  <FieldContainer
                    name="offerPrice1"
                    type="text"
                    label="سعر العرض (مستوى1)"
                    id="offerPrice1"
                  />
                )}
                <FieldContainer
                  name="productPrice2"
                  type="text"
                  label="السعر (مستوى2)"
                  id="productPrice2"
                />
                {initialValues.productName && (
                  <FieldContainer
                    name="offerPrice2"
                    type="text"
                    label="سعر العرض (مستوى2)"
                    id="offerPrice2"
                  />
                )}
                <FieldContainer
                  name="productPrice3"
                  type="text"
                  label="السعر (مستوى3)"
                  id="productPrice3"
                />
                {initialValues.productName && (
                  <FieldContainer
                    name="offerPrice3"
                    type="text"
                    label="سعر العرض (مستوى3)"
                    id="offerPrice3"
                  />
                )}

                <FieldContainer
                  name="qty_min"
                  type="number"
                  label="الحد الأدنى للكمية"
                  id="qty_min"
                />
                <FieldContainer
                  name="qty_max"
                  type="number"
                  label="الحد الأعلى للكمية"
                  id="qty_max"
                />

                <FieldContainer
                  name="noteAr"
                  type="text"
                  label="ملاحظة للعميل بالعربي (اختياري)"
                  id="noteAr"
                />
                <FieldContainer
                  name="noteEn"
                  type="text"
                  label="ملاحظة للعميل بالانجليزي (اختياري)"
                  id="noteEn"
                />
              </div>
              <DButton
                disabled={isSubmitting}
                type="submit"
                className="w-full rounded-lg mx-auto flex items-center justify-center md:max-w-[150px] text-white"
              >
                {isSubmitting ? <Spinner /> : btnText}
              </DButton>
            </Form>
          );
        }}
      </FormikContainer>
    </DCard>
  );
};

export default ProductSubForm;
